module.exports = __webpack_public_path__ + "img/icons_28.78fcadb4.png";